module.exports = __webpack_public_path__ + "static/media/flecha_mobil_14px.fa631634.svg";